import type { RadioFrequencyAccordionSection } from '@buxus/shared'
import type { ScreenInteractionContext } from './platform/analytics/interactionAnalytics'
import { BuxusAccordion } from './components/BuxusAccordion'

type Props = {
  sections: RadioFrequencyAccordionSection[]
  analytics?: ScreenInteractionContext
}

function fieldValue(value: string): string {
  return value.trim() || '—'
}

/** Mobile CommunicationsScreen radio-frequency accordion parity. */
export function RadioFrequencyAccordions({ sections, analytics }: Props) {
  const defaultExpandedIds = sections.length === 1 ? [sections[0]!.id] : undefined

  return (
    <section className="radio-frequency-section" aria-label="Radio Frequencies">
      <h2 className="content-section-heading">Radio Frequencies</h2>
      <BuxusAccordion
        className="radio-frequency-accordion"
        defaultExpandedIds={defaultExpandedIds}
        analytics={analytics}
        items={sections.map((section) => ({
          id: section.id,
          title: section.title,
          description: section.subtitle || undefined,
          content: (
            <dl className="radio-frequency-detail-list">
              <div className="radio-frequency-detail-row">
                <dt>Frequency</dt>
                <dd className="radio-frequency-detail-value--compact">
                  {fieldValue(section.frequency)}
                </dd>
              </div>
              <div className="radio-frequency-detail-row">
                <dt>System</dt>
                <dd className="radio-frequency-detail-value--compact">{fieldValue(section.system)}</dd>
              </div>
              <div className="radio-frequency-detail-row">
                <dt>Description</dt>
                <dd className="radio-frequency-detail-value--text">
                  {fieldValue(section.description)}
                </dd>
              </div>
              <div className="radio-frequency-detail-row">
                <dt>Purpose</dt>
                <dd className="radio-frequency-detail-value--text">{fieldValue(section.purpose)}</dd>
              </div>
            </dl>
          ),
        }))}
      />
    </section>
  )
}
